module.exports = __webpack_public_path__ + "img/dzp.fc401d15.png";